






import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const log = require('./CHANGELOG.md')

@Component
export default class Changelog extends Vue {
  log = log
}
